import { render, staticRenderFns } from "./refundList.vue?vue&type=template&id=73bbcbed&scoped=true"
import script from "./refundList.vue?vue&type=script&lang=js"
export * from "./refundList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bbcbed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73bbcbed')) {
      api.createRecord('73bbcbed', component.options)
    } else {
      api.reload('73bbcbed', component.options)
    }
    module.hot.accept("./refundList.vue?vue&type=template&id=73bbcbed&scoped=true", function () {
      api.rerender('73bbcbed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/order/refundList.vue"
export default component.exports